// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__MaVS7","title":"Projects_title__iXV9H","subtitle":"Projects_subtitle__uZhFS","grid":"Projects_grid__iLaXj"};